import { Link } from 'react-router-dom';

export default function AdobePDFHero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('https://public.readdy.ai/ai/img_res/557e073a0e28ff86524e8a15f5edef15.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center text-white">
          <h1 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight">
            <strong>Adobe PDF Library</strong>
            <span className="block bg-gradient-to-r from-teal-400 via-cyan-400 to-teal-500 bg-clip-text text-transparent">企业级PDF处理引擎</span>
          </h1>
          <p className="text-xl lg:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
            基于<strong>Adobe技术</strong>的强大<strong>PDF SDK</strong>，为您的应用程序提供完整的<strong>PDF处理能力</strong>
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/contact"
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              申请试用
            </Link>
            <a 
              href="#features"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              了解更多
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
